module.exports = __webpack_public_path__ + "static/media/startpage2026.5a7f7fa3.jpg";